import { useQuery } from "@tanstack/react-query";
import { notificationsApi } from "../services/notificationsApi";

export const NOTIFICATIONS_UNREAD_COUNT_KEY = ["notifications", "unread-count"] as const;

/// Polls every 60 seconds while the bell is mounted. When SignalR-driven
/// pushes are wired in the future, swap the implementation without touching
/// callers.
export const useUnreadCount = () =>
  useQuery({
    queryKey: NOTIFICATIONS_UNREAD_COUNT_KEY,
    queryFn: notificationsApi.getUnreadCount,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    staleTime: 0,
  });
